export default "__VITE_ASSET__BrzwODrO__"